import { useState, useEffect } from "react";

export default function useDeviceCatalog() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchDevices() {
      try {
        const response = await fetch("/api/devices");
        if (!response.ok) {
          throw new Error(`Failed to fetch devices: ${response.status}`);
        }
        const data = await response.json();
        if (!cancelled) {
          setDevices(data);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      }
    }

    fetchDevices();

    document.addEventListener("catalog:refresh", fetchDevices);
    return () => {
      cancelled = true;
      document.removeEventListener("catalog:refresh", fetchDevices);
    };
  }, []);

  return { devices, loading, error };
}
